import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import AuthMenu from './auth-menu';
import {Link, Route, Switch, withRouter} from "react-router-dom";
import {NavbarToggler} from "reactstrap";
import assets from '../../assets';
import GameComponent from "../game/game-component";

class Navbar extends GameComponent {

    constructor(params) {
        super(params);
        this.state = { toggle: false }
    }

    toggleMobile = (e) => {
        e.preventDefault();
        this.props.sidebarToggleMobile();
    };

    toggleDesktop = (e) => {
        e.preventDefault();
        this.props.sidebarToggle();
    };

    toggle = () => {
        this.setState({...this.state, toggle: !this.state.toggle});
    };

    hide = () => {
        this.setState({...this.state, toggle: false});
    };

    render() {
        return (
            <nav className="navbar page-header navbar-light navbar-expand-lg fixed-top bg-white">
                <div className='upper-menu'>
                    <Link to='/' className="navbar-brand"><img src={assets.rozpoctisito} id='logo'/></Link>
                    <NavbarToggler onClick={this.toggle}/>
                    <div className={`collapse navbar-collapse ${this.state.toggle ? 'show' : ''}`}>
                        <AuthMenu hide={this.hide}/>
                        <ul className="navbar-nav">
                            <li className="nav-item dropdown">
                                <a href='/o-projektu' className='nav-link'>O projektu</a>
                            </li>
                            <li className="nav-item dropdown">
                                <a href="https://minihra.rozpoctisito.eu" className='btn btn-white-secondary'>Hraj minihru</a>
                            </li>
                            <li className="nav-item dropdown">
                                <Link to='/zapoj-se' className='btn btn-pink'>Zapoj se do soutěže</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                { this.props.children }
            </nav>
        )
    }
}


function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance,
        auth: state.auth,
        sidebarToggle: ownProps.sidebarToggle,
        sidebarToggleMobile: ownProps.sidebarToggleMobile
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Navbar));
